<template>
  <div class="app-wrapper">
    <el-drawer :visible.sync="show3" :modal="false" direction="ltr" v-if="$route.path === '/index'"
      ><sidebar class="sidebar-container"></sidebar>
    </el-drawer>
    <sidebar class="sidebar-container" v-else></sidebar>
    <div class="rightIcon"
      v-if="$route.path === '/index'&&!$store.state.fullScreen"
      @click="show3 = !show3"
      style="position: absolute; z-index: 15"
    ><span class="el-icon-menu"></span>主菜单</div>
    <div class="main-container">
      <div class="main-top">
        <div class="fl">
          <img :src="$store.state.systemData.logo" class="logo" /><span
            class="name"
            >{{ $store.state.systemData.name }}</span
          >
        </div>
        <div class="fr">
          <el-dropdown @command="handleCommand">
            <span class="el-dropdown-link">
              <i class="iconfont">&#xe638;</i><em>{{ userName }}</em>
              <i class="el-icon-arrow-down"> </i>
            </span>
            <el-dropdown-menu slot="dropdown" class="el-dropdown-menu">
              <el-dropdown-item command="modify">修改密码</el-dropdown-item>
              <el-dropdown-item command="out">退出</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>

      <app-main></app-main>
      <modify-pass
        v-if="modifyPassShow"
        @cancel="cancel"
        @submit="submit"
      ></modify-pass>
    </div>
  </div>
</template>
a
<script>
import AppMain from "@/views/layout/components/AppMain"; //页面布局的右侧区域
import sidebar from "@/views/layout/components/sidebar"; //页面布局的左侧菜单
import modifyPass from "@/views/layout/components/modifyPass"; //页面布局的左侧菜单

export default {
  name: "layout",
  components: {
    sidebar,
    AppMain,
    modifyPass,
  },
  data() {
    return {
      modifyPassShow: false,
      userName: "",
      form: {},
      show3: true,
    };
  },
  watch:{
    $route() {
       if (this.$route.path === "/index") {
        this.show3 = false;
      }
    },
  },
  beforeCreate() {
      WAPI.getMenuByRoleId({}).then((menuData) => {
          if(menuData.code===200){
            localStorage.setItem("menuData", JSON.stringify(menuData.data));
            if (
              !this.commonApi.isNull(menuData.data) &&
              menuData.data.length > 0
            ) {
              this.commonApi.setPermissionUrl(this,menuData.data,'按钮权限')
            } else {
              this.$router.push({ path: "/login" });
            }
          }
            this.commonApi.checkNo=1
      });
  },
  mounted() {
    this.userName = localStorage.getItem("userName");
    this.getData();
    if (this.$route.path === "/index") {
      this.show3 = false;
    }
  },
  methods: {
    getData() {
      WAPI.getSysManagementList({}).then((data) => {
        switch (data.code) {
          case 200:
            this.form = data.data[0];
            if(this.form.length===0){
            this.$store.commit("setSystemData", {logo:"",name:""});
            }else{
            this.$store.commit("setSystemData", this.form);
            }
        }
      });
    },
    cancel() {
      this.modifyPassShow = false;
    },
    submit() {
      localStorage.setItem("token", "");
      this.$router.push("/login");
    },
    handleCommand(command) {
      if (command === "modify") {
        this.modifyPassShow = true;
      } else {
        const that = this;
        localStorage.setItem("token", "");
        that.$router.push("/login");
        return;
        that.common.submitForm(
          that,
          "post",
          "/auth/login?method=loginOut",
          {},
          function () {
            that.$store.commit("auth_success", "");
            that.$router.push("/login");
          }
        );
      }
    },
  },
};
</script>

<style scoped lang="scss">
.app-wrapper {
  position: relative;
  height: 100%;
  width: 100%;
}
.logo {
  height: 44px;
  float: left;
  margin: 3px 0;
  margin-left: 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/layout/index.vue